import { render, staticRenderFns } from "./PostMortem.vue?vue&type=template&id=e97e16f4&scoped=true&"
import script from "./PostMortem.vue?vue&type=script&lang=ts&"
export * from "./PostMortem.vue?vue&type=script&lang=ts&"
import style0 from "./PostMortem.vue?vue&type=style&index=0&id=e97e16f4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e97e16f4",
  null
  
)

export default component.exports